// loadScript function is defined globally
function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true; 
        
        script.onload = () => {
             console.log(`loaded`);
            resolve();
        };
        
        script.onerror = () => {
            console.error(`Failed to load: ${url}`);
            reject(new Error(`Failed to load ${url}`));
        };
        
        document.head.appendChild(script);
    });
}

// Global utility functions
function formatAnswerText(text) {
    return text
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') 
        .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>')
        .replace(/\n/g, '<br>');
}

function hideResults() {
    const resultsContainer = document.getElementById('faq-search-results');
    if (resultsContainer) {
        resultsContainer.innerHTML = '';
        resultsContainer.style.display = 'none';
    }
}

/**
 * FAQ Deflector Script - Dynamic Container Version
 * Encapsulated for clean execution and scope management.
 */
function initializeFAQ() {
    // --- Configuration Variables (Scoped to initializeFAQ) ---
    let fuse = null;
    let faqData = [];
    let resultsContainer = null;
    let descriptionInput = null;

    function debounce(func, wait) {
        let timeout;
        return function execute(...args) {
            const later = () => {
                clearTimeout(timeout);
                func.apply(this, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    async function initSearch() {
        try {
            //Load Fuse.js and wait for it
            const FUSE_JS_CDN = 'https://cdn.shopify.com/s/files/1/1281/4359/files/hk-fuse.min.js';
            await loadScript(FUSE_JS_CDN); 

            // --- 1. Get Textarea ID ---
            const textarea = document.querySelector('form textarea');
            if (!textarea) {
                console.warn('FAQ Deflector: Could not find the required textarea. Aborting.');
                return;
            }
            
            const currentPageUrl = window.location.href.toLowerCase();
            const ELEMENT_IDS = {
                description: textarea.id,
                resultsContainer: 'faq-search-results',
            };

            descriptionInput = document.getElementById(ELEMENT_IDS.description);

            if (!descriptionInput) {
                console.warn('FAQ Deflector: Could not find description input by ID. Aborting.');
                return;
            }

            // 2. DYNAMICALLY CREATE AND INSERT THE RESULTS CONTAINER
            resultsContainer = document.createElement('div');
            resultsContainer.id = ELEMENT_IDS.resultsContainer;
            resultsContainer.className = 'faq-results-container';
            
            descriptionInput.insertAdjacentElement('afterend', resultsContainer);
            resultsContainer.style.display = 'none'; 

            // 3. JSON URL Logic
            const devUrl = 'https://cdn.shopify.com/s/files/1/1377/5437/files/hk-faq-data.json';
            const liveUrl = 'https://cdn.shopify.com/s/files/1/1281/4359/files/hk-faq-data.json';
            let jsonFileUrl = (currentPageUrl.includes('asep-dev1') || currentPageUrl.includes('hkdev1')) ? devUrl : liveUrl;

            // 4. Fetch the FAQ data
            const response = await fetch(jsonFileUrl);

            if (!response.ok) throw new Error('Failed to fetch faq-data.json');
            faqData = await response.json();

            // 5. Configure Fuse.js
            const options = {
                keys: [
                    { name: 'question', weight: 0.5 },    // Default weight
                    { name: 'answer', weight: 0.3 },      // Default weight
                    { name: 'keywords', weight: 0.9 }     // INCREASED WEIGHT for the critical keywords
                ],
                threshold: 0.5,
                includeScore: true,
                minMatchCharLength: 3,
                ignoreFieldNorm: true,
                ignoreLocation: true
            };
            fuse = new Fuse(faqData.items, options);

            // 6. Add event listeners
            const debouncedSearch = debounce(runSearch, 350); 
            
            descriptionInput.addEventListener('input', (e) => {
                debouncedSearch(e.target.value);
            });
            console.log('initialized and listeners attached.');

        } catch (error) {
            console.error('FAQ Deflector Initialization Error:', error);
        }
    }

    function runSearch(query) {
        if (!fuse) return; // Silent return if still loading

        if (query.trim().length < 3) {
            hideResults();
            return;
        }
        
        const results = fuse.search(query);
        const topResults = results.slice(0, 4).map(result => result.item);
        
        displayResults(topResults);
    }

    function displayResults(items) {
        if (!items || items.length === 0) {
            hideResults();
            return;
        }
        // ... (rest of displayResults implementation) ...
        
        resultsContainer.innerHTML = '';

        //Add a close button at the top
        const closeButton = document.createElement('button');
        closeButton.className = 'faq-close-button';
        closeButton.textContent = 'Close';
        closeButton.setAttribute('aria-label', 'Close search results');
        closeButton.addEventListener('click', hideResults);
        resultsContainer.appendChild(closeButton);

        const resultsList = document.createElement('ol');
        resultsList.className = 'faq-results-list';

        items.forEach(item => {
            const li = document.createElement('li');
            li.className = 'faq-results-item';
            
            li.innerHTML = `
                <button type="button" class="faq-result-question" data-faq-id="${item.id}">
                    ${item.question}
                </button>
                <div class="faq-result-answer" style="display: none;">
                    ${formatAnswerText(item.answer)}
                    <p class="faq-close-instruction" style="margin-top:12px;font-style:italic;font-size:0.9em;">
                        Click <a href="#" onclick="hideResults(); return false;">here</a> to dismiss this message and 
                        continue filling out the form if you need additional help.
                    </p>
                </div>
            `;
            resultsList.appendChild(li);
        });
        
        resultsContainer.appendChild(resultsList);
        resultsContainer.style.display = 'block';

        resultsContainer.querySelectorAll('.faq-result-question').forEach(button => {
            button.addEventListener('click', toggleAnswer);
            button.addEventListener('mousedown', (e) => e.preventDefault());
        });
    }

    function toggleAnswer(event) {
        event.preventDefault();
        
        const button = event.currentTarget;
        const answerDiv = button.nextElementSibling;
        
        const allAnswers = resultsContainer.querySelectorAll('.faq-result-answer');
        allAnswers.forEach(ans => {
            if (ans !== answerDiv) {
                ans.style.display = 'none';
                ans.previousElementSibling.classList.remove('active');
            }
        });

        const isVisible = answerDiv.style.display === 'block';
        answerDiv.style.display = isVisible ? 'none' : 'block';
        button.classList.toggle('active', !isVisible);
    }

    
    // --- EXECUTION LOGIC: The Robust Readiness Check ---
    // Set up the named listener to unregister itself
    document.addEventListener('readystatechange', function handler(event) {
        if (document.readyState === 'interactive') {
            document.removeEventListener('readystatechange', handler); 
            initSearch(); 
        }
    });

    //Fallback: If the script loads after the page is already interactive/complete
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        initSearch();
    }
}

// Start the whole script
initializeFAQ();